import ManagerAdd from './ManagerAdd';

export default ManagerAdd;
